import { handleError } from "core/utils/HandleError";
import { handleResponse } from "core/utils/HandleResponse";
import { AuthHttpClient } from "core/utils/HttpClient";
import { chatHttpClient } from "core/utils/HttpSocketClient";
import { OpenModeratorTagRow } from "core/models/PlayoffRound";

export function getTournamentPlayOff(palyoffId: string) {
  return AuthHttpClient.get(`/core/tournament/playoff/${palyoffId}`, {
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getTournamentPlayOffBattleRoyale(palyoffId: string) {
  return AuthHttpClient.get(`/core/tournament/playoff/battle-royale/${palyoffId}`, {
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getTournamentMatchChatMessages({
  limit,
  roomId,
  page,
}: {
  limit: number;
  roomId: string;
  page: number;
}) {
  return chatHttpClient
    .get(`/rooms/match/${roomId}/messages`, {
      params: { limit, page },
    })
    .then((response: any) => response.data)
    .catch(handleError);
}

export function getOpenModeratorMatchTags(params?: {
  tournamentId?: string;
  playoffId?: string;
}) {
  const search =
    params?.tournamentId || params?.playoffId
      ? {
          ...(params?.tournamentId
            ? { tournamentId: params.tournamentId }
            : {}),
          ...(params?.playoffId ? { playoffId: params.playoffId } : {}),
        }
      : undefined;  
  return chatHttpClient
    .get<OpenModeratorTagRow[]>(`/rooms/match/open-moderator-tags`, {
      params: search,
    })
    .then((response) => response.data)
    .catch(handleError);
}

export function resolveModeratorMatchTag(messageId: string) {
  return chatHttpClient
    .patch(`/rooms/match/messages/${messageId}/moderator-tag`, {
      status: "resolved",
    })
    .then((response: any) => response.data)
    .catch(handleError);
}
